interface IWidgetConfig {
    AUTOMATIC_RESIZE: boolean;
    API_URL: string;
    CART_URL: string,
    ENDPOINT_FOR_ERRORS: string
}

const apiUrl = (() => {
    if (process.env.REACT_APP_ENV === "LOCAL")
        return "https://localhost:5501";
    if (process.env.REACT_APP_ENV === "DEV")
        return "https://megawidget2-ss.k8s.mednet.world";
    if (process.env.REACT_APP_ENV === "PREPROD")
        return "https://megawidget2.preprod.k8s.mednet.world";
    if (process.env.REACT_APP_ENV === "PROD")
        return "https://megawidget2.medicover.pl";
})()

const config: IWidgetConfig = {
    AUTOMATIC_RESIZE: true,
    API_URL: apiUrl as string,
    CART_URL: "https://medicover-test.medistore.com.pl/",
    ENDPOINT_FOR_ERRORS: `${apiUrl as string}/api/widget/LogError`
}

console.log(process.env.REACT_APP_ENV);

export default config;